<script lang="ts">
  import {Range} from '../field/components';
  import {preview} from '../../store';
  import {getInstance} from '@/services/animation';
  import {videoScale} from '@/store/scale';
  import {onDestroy} from 'svelte';
  import editorStore from '@/lib/editor/editor.store';
  import editorInstance from '@/lib/editor/editor';
  import {writable} from 'svelte/store';
  import { tooltip } from '@/actions/tippy-action';

  let videoHeight = 0;
  let videoWidth = 0;
  let scale = 100;
  let checked = writable(true);

  function onCheckChange() {
    console.log('change');
  }

  const subscription = videoScale.subscribe(value => {
    videoHeight = value.videoHeight;
    videoWidth = value.videoWidth;
  });

  function volumeChange(e: CustomEvent) {
    getInstance().setVideoVolume(e.detail.value);
    preview.set({videoLevel: e.detail.value});
  }

  function scaleChange() {
    if (videoHeight === 0 || videoWidth === 0) return;
    const percentScale = scale / 100;
    const div = document.querySelector('[data-amelement="sermonclip"]') as HTMLDivElement;
    if (!div) return;
    div.style.height = `${videoHeight * percentScale}px`;
    div.style.width = `${videoWidth * percentScale}px`;
  }
  let focusMode = false;

  function selectVideo() {
    const sermonClip = editorInstance.querySelector('[data-amelement="sermonclip"]');
    if (!sermonClip) return console.log('sermonclip element not found');

    editorStore.setActiveComponent(sermonClip, undefined, {activePopoverLabel: 'Sermon Clip'});
    if (!focusMode) {
      editorInstance.activateFocusMode();
      focusMode = true;
    } else {
      editorInstance.disableFocusMode();
      focusMode = false;
    }
  }

  onDestroy(() => subscription());
</script>

<div class="w-full">
  <div class="w-full pt-4">
    <div class="flex w-full items-center pb-4">
      <div class="flex items-center gap-1">
        <span class="flex items-center gap-1 font-bold">
          <!-- <i class="fa-solid fa-maximize"></i> -->
          Scale
        </span>
      </div>
      <div class="ml-auto">
        <h2 class="rounded-md border bg-zinc-100 px-2 py-1 text-xs font-bold">{scale}%</h2>
      </div>
    </div>
    <Range bind:value={scale} on:change={scaleChange} step={1} minValue={0} maxValue={200} />
  </div>
  <div class="flex w-full items-center justify-between pb-4 pt-8">
    <span class="font-bold">Adjust Clip Position</span>
    <button
      on:click={() => selectVideo()}
      class="flex items-center gap-1 rounded-lg border bg-primary px-2 py-3 text-xs font-bold text-white"
    >
      <i class="fa-solid fa-arrows-maximize"></i>
      Move Clip
    </button>
  </div>
  <div class="w-full pt-8">
    <div class="flex items-center gap-1 pb-4">
      <span class="flex items-center gap-1 font-bold">
        <!-- <i class="fa-solid fa-volume"></i> -->
        Volume
      </span>
      <h2 class="ml-auto rounded-md border bg-zinc-100 px-2 py-1 text-xs font-bold">{$preview.videoLevel}%</h2>
    </div>
    <Range bind:value={$preview.videoLevel} on:change={volumeChange} step={1} minValue={0} maxValue={100} />
  </div>
  <div class="w-full pt-8">
    <div class="flex items-center gap-1 pb-4">
      <span class="flex items-center gap-1 font-bold" id="video_fade_tip">
        <!-- <i class="fa-solid fa-volume"></i> -->
        Video Fade
        <i class="fa-solid fa-circle-info cursor-pointer text-lg text-gray-300"
          use:tooltip={"Fade won’t show in the preview. Please download the clip to see the effect applied."}
            ></i>
      </span>

      <label class="relative ml-auto inline-flex cursor-pointer items-center">
        <input
          type="checkbox"
          value=""
          class="peer sr-only"
          bind:checked={$preview.videoFade}
          on:change={onCheckChange}
        />
        <div
          class="peer h-6 w-11 rounded-full bg-gray-200 after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-secondary peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-200 dark:border-gray-600 dark:bg-secondary dark:peer-focus:ring-secondary-600"
        />
      </label>
    </div>
  </div>
</div>
